import type L from "leaflet";
import type { CanvasPinIcon } from "./CanvasPinIcon";
import type { CanvasPinMarker } from "./CanvasPinMarker";

export interface CanvasPinUpdatableProps {
  position: L.LatLngExpression;
  icon: CanvasPinIcon;
  selectedIcon?: CanvasPinIcon;
}

/**
 * CanvasPin（react-leaflet のコンポーネント）の props が変わった時に、ピンへ反映する。
 * 位置と見た目（ふだん・選択中）だけを、変わった時にだけ更新する
 */
export const updateCanvasPin = (
  marker: CanvasPinMarker,
  props: CanvasPinUpdatableProps,
  prevProps: CanvasPinUpdatableProps
): void => {
  if (props.position !== prevProps.position) {
    marker.setLatLng(props.position);
  }
  if (props.icon !== prevProps.icon) {
    marker.setIcon(props.icon);
  }
  if (props.selectedIcon !== prevProps.selectedIcon) {
    marker.setSelectedIcon(props.selectedIcon);
  }
};
